import React from 'react';
import { DialogActions } from '@material-ui/core';

interface EeModalActionsProps {
  children: React.ReactNode;
}

export const EeModalActions: React.FC<EeModalActionsProps> = ({ children }) => {
  return <DialogActions>{children}</DialogActions>;
};
